import { abrirAbaCarregando, direcionarAbaArquivo, fecharAba, showError } from '_metronic/helpers'
import { ArquivoDto } from '../../../../atendimento/core/_models'

/**
 * Abre o PDF numa aba nova. A aba é aberta já no clique (antes do `await`), para o navegador
 * (e o iOS em especial) não bloquear como pop-up.
 */
export const visualizarArquivo = async (buscar: () => Promise<ArquivoDto>) => {
  const aba = abrirAbaCarregando()
  try {
    direcionarAbaArquivo(aba, await buscar())
  } catch (error) {
    fecharAba(aba)
    showError(error)
  }
}
